import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Select from '../../../../../../packages/kiti/components/form/Select'

export const EditRankingForm = () => {
  const { t } = useTranslation('common')

  return (
    <>
      <Col width="100%">
        <FormItem
          label={t('widgets.perspective')}
          path={['data', 'perspective']}
          Input={Select}
          options={[
            { id: 'user', name: t('widgets.usersCounter.category') },
            { id: 'place', name: t('widgets.placesCounter.category') },
            { id: 'checklist', name: t('widgets.checklistsRanking.category') }
          ]}
          disableEmptyOption
          selectOnlyId
        />
      </Col>
    </>
  )
}
